import { RESET_CALL_SETTINGS, TOGGLE_REMEMBER_SETTINGS, TOGGLE_AUDIO_TEST } from 'constants/AvSettingsModal';

let speakerTimeout;

export function resetCallSettings() {
  return {
    type: RESET_CALL_SETTINGS
  };
}

export function toggleRememberSettings() {
  return {
    type: TOGGLE_REMEMBER_SETTINGS
  };
}

export function setAudioTestingState(toggle) {
  return {
    type: TOGGLE_AUDIO_TEST,
    payload: toggle
  };
}

export function toggleAudioTest(toggle) {
  return async (dispatch) => {
    clearTimeout(speakerTimeout);
    dispatch(setAudioTestingState(toggle));
    if (toggle) {
      speakerTimeout = setTimeout(() => {
        dispatch(toggleAudioTest(false));
      }, 4600);
    }
  };
}

export default {
  toggleAudioTest,
  setAudioTestingState,
  resetCallSettings,
  toggleRememberSettings
};
